import React, { Component, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PrivateRoute from './protectedRoutes';

import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Orders from '../pages/Orders';
import Clients from '../pages/Clients';
import Init from '../pages/Init';

class AppRoutes extends Component {
  render() {
    return (
      <BrowserRouter>
       <Suspense fallback={ "" }>
         <Routes>

          <Route exact path='/' element={<Init/>}/>

          <Route exact path="/login" element={<Login/>} />

          <Route exact path='/user' element={<PrivateRoute/>}>
            <Route exact path='/user' element={<Dashboard/>}/>
          </Route>

          <Route exact path='/clients' element={<PrivateRoute/>}>
            <Route exact path='/clients' element={<Clients/>}/>
          </Route>

          <Route exact path='/orders' element={<PrivateRoute/>}>
            <Route exact path='/orders' element={<Orders/>}/>
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
    );
  }
}

export default AppRoutes;
